/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Auth_Privacy_PolicyInputs */



/**
* | output |
* | --- |
* | "Privacy Policy" |
*
* @param {Auth_Privacy_PolicyInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const auth_privacy_policy = /** @type {((inputs?: Auth_Privacy_PolicyInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Auth_Privacy_PolicyInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Datenschutzrichtlinie")
	return /** @type {LocalizedString} */ ("Privacy Policy")
});